import { emptySplitApi } from "./empty-split-api";
import type {
  CoachCueFeedbackRequest,
  CoachSession,
  CreateCoachSessionRequest
} from "./types/coach-sessions.type";

export const coachSessionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    createCoachSession: builder.mutation<
      CoachSession,
      CreateCoachSessionRequest
    >({
      query: (body) => ({
        url: "/coach/sessions/",
        method: "POST",
        body
      })
    }),
    endCoachSession: builder.mutation<void, string>({
      query: (sessionId) => ({
        url: `/coach/sessions/${sessionId}/`,
        method: "DELETE"
      })
    }),
    sendCoachCueFeedback: builder.mutation<void, CoachCueFeedbackRequest>({
      query: ({ cueId, vote }) => ({
        url: `/coach/cues/${cueId}/feedback/`,
        method: "POST",
        body: { vote }
      })
    })
  })
});

export const {
  useCreateCoachSessionMutation,
  useEndCoachSessionMutation,
  useSendCoachCueFeedbackMutation
} = coachSessionsApi;
